import { IErrorReport } from './interface'
import { SentryErrorReport } from './sentry-error-report'

const errorReport: IErrorReport = new SentryErrorReport()
export default errorReport
